import { FiApplicationLanguageType } from './fi-application-language-type';

export function getTextIdByApplicationLanguageType(applicationLanguageType: FiApplicationLanguageType) {
    let textId: string = 'language.unknown';
    switch (applicationLanguageType) {
        case FiApplicationLanguageType.Swedish:
            textId = 'language.swedish';
            break;
        case FiApplicationLanguageType.English:
            textId = 'language.english';
            break;
        case FiApplicationLanguageType.Danish:
            textId = 'language.danish';
            break;
        case FiApplicationLanguageType.Norwegian:
            textId = 'language.norwegian';
            break;
        case FiApplicationLanguageType.Finnish:
            textId = 'language.finnish';
            break;
        case FiApplicationLanguageType.French:
            textId = 'language.french';
            break;
        case FiApplicationLanguageType.Estonian:
            textId = 'language.estonian';
            break;
        case FiApplicationLanguageType.Spanish:
            textId = 'language.spanish';
            break;
        case FiApplicationLanguageType.German:
            textId = 'language.german';
            break;
        case FiApplicationLanguageType.Italian:
            textId = 'language.italian';
            break;
        case FiApplicationLanguageType.Chinese:
            textId = 'language.chinese';
            break;
        case FiApplicationLanguageType.Mongol:
            textId = 'language.mongol';
            break;
        case FiApplicationLanguageType.Catalan:
            textId = 'language.catalan';
            break;
        case FiApplicationLanguageType.Dutch:
            textId = 'language.dutch';
            break;
        case FiApplicationLanguageType.Arabic:
            textId = 'language.arabic';
            break;
        case FiApplicationLanguageType.Vietnamese:
            textId = 'language.vietnamese';
            break;
        case FiApplicationLanguageType.Icelandic:
            textId = 'language.icelandic';
            break;
        case FiApplicationLanguageType.Turkish:
            textId = 'language.turkish';
            break;
    }

    return textId;
}
